import React from "react";

import styles from "../../../../styles/sort-categories-products.module.scss";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Hairline } from "../../../components/Hairline";
import { Message } from "../../../components/Message";
import { Icon } from "../../../components/core/Icon";
import SortItems from "../../../components/SortItems";

const SortTypes = {
  ALPHABETICAL: 'alphabetical'
};

const Sorts = {
  [SortTypes.ALPHABETICAL]: 'Ordem alfabética'
};

export default class SortProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      sortedProducts: [],
      loading: false
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (!prevProps.category && this.props.category ) {
      this.updateSort(this.props.category?.items || []);
    }

    if ((prevProps.category && prevProps.category?.id !== this.props.category?.id )) {
      this.updateSort(this.props.category?.items || []);
      this.setState({ step: 1 });
    }
  }

  async componentDidMount() {
    this.updateSort(this.props.category?.items || []);
	}

  async save () {
    const { onSave, category } = this.props;
    const { sortedProducts } = this.state;

    this.setState({
      loading: true
    });

    const updatedCategory = {
      ...category,
      items: sortedProducts
    };
    await onSave(updatedCategory);

    this.setState({
      loading: false
    });
  }

  updateSort (sortedProducts) {
    this.setState({
      sortedProducts
    });
  }

  updateSortType (sortType) {
    const products = this.props.category.items;
    if (sortType === SortTypes.ALPHABETICAL) {
      
      products.sort((a, b) => a.name.localeCompare(b.name));

      this.setState({
        sortedProducts: products.map((product, index) => ({ ...product, position: index })),
        step: 1
      }, () => { this.save() });
    }
  }

  render() {
    const { step, sortedProducts, loading } = this.state;
    const { open, setOpen } = this.props;

    return (
      <Drawer
        visible={open}
        onClose={(status) => setOpen(false)}
        title="Ordenar - Produtos"
        showBackButton={step === 2}
        backButton={() => this.setState({ step: 1 })}
        footer={
          step === 1 && (
            <Button design="primary" className="w-100" loading={loading} disabled={loading}  onClick={() => this.save()} >
              Aplicar
            </Button>
          )
        }
      >
        {step === 1 && (
          <>
            <div className="d-flex justify-center">
              <Button
                design="underline"
                onClick={() => this.setState({ step: 2 })}
              >
                VER ORDERNS PRÉ-DEFINIDAS
              </Button>
            </div>

            <Hairline />

            <div className={styles.products}>
              <SortItems
                items={sortedProducts}
                callback={(newOrder) => this.updateSort(newOrder)}
              />
            </div>
          </>
        )}

        {step === 2 && (
          <>
            {( Object.entries(Sorts).map(([sortType, sortName]) => 
              <div className="d-flex justify-between">
                <span className={styles.sortType}>{ sortName }</span>
                <Button 
                  design="underline" 
                  onClick={() => this.updateSortType(sortType)} 
                >
                  Aplicar
                </Button> 
              </div>
            ))}

            <Hairline />

            <Message>
              Você pode voltar ao modo manual para realizar uma alteração.
            </Message>
          </>
        )}
      </Drawer>
    );
  }
}
